import { isNavigationFailure, type NavigationHookAfter } from "vue-router";

/**
 * Hack to notify AngularJS that url was changed externally.
 */
export function notifyNgUrlChangeHook(): NavigationHookAfter {
  return (to, from, failure) => {
    if (!isNavigationFailure(failure)) {
      window.dispatchEvent(new Event("$$$urlchange$$$"));
    }
  };
}
